const SCROLL_EDGE_ATTR = 'data-scroll-edge';

    function maxScrollLeft(scroller) {
        return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    }

    function getScrollEdgeMask(scroller) {
        const max = maxScrollLeft(scroller);
        if (max <= 1) {
            return 'none';
        }
        const atStart = scroller.scrollLeft <= 1;
        const atEnd = scroller.scrollLeft >= max - 1;
        if (!atStart && !atEnd) {
            return 'both';
        }
        if (!atStart) {
            return 'start';
        }
        if (!atEnd) {
            return 'end';
        }
        return 'none';
    }

    function setWrapScrollFadeClasses(scroller, wrap, startClass, endClass) {
        const max = maxScrollLeft(scroller);
        const hasOverflow = max > 1;
        wrap.classList.toggle(startClass, scroller.scrollLeft > 1);
        wrap.classList.toggle(endClass, hasOverflow && scroller.scrollLeft < max - 1);
    }

    function clearWrapScrollFadeClasses(wrap, startClass, endClass) {
        wrap.classList.remove(startClass, endClass);
    }

    function setScrollEdgeMask(scroller, element) {
        element.setAttribute(SCROLL_EDGE_ATTR, getScrollEdgeMask(scroller));
    }

    function clearScrollEdgeMask(element) {
        element.removeAttribute(SCROLL_EDGE_ATTR);
    }

export {
    maxScrollLeft,
    getScrollEdgeMask,
    setWrapScrollFadeClasses,
    clearWrapScrollFadeClasses,
    setScrollEdgeMask,
    clearScrollEdgeMask
};
